<template>
  <logo :opposite-color="isMenuOpen"/>
</template>

<script>
import { mapState } from 'vuex'
import Logo from '@/components/Logo'

export default {
  components: {
    Logo
  },
  computed: {
    ...mapState({
      isMenuOpen: state => state.nav.isMenuOpen
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Navigation/LogoContainer.vue